import React from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import clsx from 'clsx';
import { LAYOUT_BREAKPOINT } from 'UI/components/organisms/inventoryProfiles/commons';
import { SHARED_SKELETONS_PROPS } from 'UI/components/organisms/inventoryProfiles/SkeletonWrapper/constants';

import ContentPageLayout, { PageHeadline } from '../ContentPageLayout';

import ActionsBar from './ActionsBar';
import { SETTINGS_GRID_CONFIG } from './constants';
import { useStyles } from './styles';

/** @typedef {import('types/app').ContentPageLayoutProps} ContentPageLayoutProps */
const { buttons } = SHARED_SKELETONS_PROPS;

/**
 * @typedef {Object} HeaderCardProps
 * @property {string} [sectionName]
 * @property {string} [title]
 * @property {*} [titleLabelProps]
 */

/**
 * @param {Object} props
 * @param {React.ReactNode} props.actionsBar
 * @param {*} [props.additionalHeaderActions]
 * @param {ContentPageLayoutProps} props.contentPageLayoutProps
 * @param {HeaderCardProps} [props.headerCardProps]
 * @param {React.ReactNode} props.headerContent
 * @param {boolean} [props.isLoading=false]
 * @param {Array<Object>} [props.menuItems]
 * @param {React.ReactNode} props.pageContent
 * @param {React.ReactNode} props.statusBar
 * @param {string} props.subtitle
 * @param {Object} props.additionalCardClasses
 */
const FullWidthCardHeader = ({
  actionsBar,
  additionalHeaderActions,
  contentPageLayoutProps,
  headerCardProps: { sectionName, title, titleLabelProps },
  headerContent,
  isLoading,
  menuItems,
  pageContent,
  statusBar,
  subtitle,
  additionalCardClasses
}) => {
  const classes = useStyles();
  const isSmallViewPort = useMediaQuery(LAYOUT_BREAKPOINT);

  const actionsBarConfig = additionalHeaderActions
    ? SETTINGS_GRID_CONFIG.actionBar.headerActions
    : SETTINGS_GRID_CONFIG.actionBar.headerWithoutActions;

  const customTitleGridConfig = additionalHeaderActions
    ? SETTINGS_GRID_CONFIG.titleBar.headerActions
    : SETTINGS_GRID_CONFIG.titleBar.headerWithoutActions;

  return (
    <ContentPageLayout mode="customLayout" {...contentPageLayoutProps}>
      {statusBar}
      <div className={clsx(classes.fullWidthCard, additionalCardClasses)}>
        <PageHeadline
          actionsBarConfig={actionsBarConfig}
          customTitleGridConfig={customTitleGridConfig}
          pageHeadlineGrid={isSmallViewPort && { direction: 'column-reverse' }}
          sectionName={sectionName}
          text={title}
          titleLabelProps={{
            backNavigation: true,
            ...titleLabelProps,
            loading: isLoading,
            subtitle,
            subtitleProps: { variant: 'overline', className: classes.overline }
          }}
          actionsBar={
            <ActionsBar
              isLoading={isLoading}
              buttons={buttons}
              actionsBar={actionsBar}
              additionalHeaderActions={additionalHeaderActions}
              menuItems={menuItems}
            />
          }
        />
        {headerContent}
      </div>
      {pageContent}
    </ContentPageLayout>
  );
};

FullWidthCardHeader.defaultProps = {
  additionalHeaderActions: null,
  menuItems: [],
  headerCardProps: { sectionName: '', title: '', titleLabelProps: null },
  isLoading: false
};

export default FullWidthCardHeader;
